const linkBlockAppDeepLink = (intl, methodName) => ({
  name: intl.formatMessage({ id: 'name' }),
  'scheme name': intl.formatMessage({ id: 'linkBlockDeepLinkScheme.scheme_name' }),
  ...(methodName => {
    switch (methodName) {
      default:
        return {};
    }
  })(methodName),
});

export default linkBlockAppDeepLink;
